import { createJSONStorage } from 'zustand/middleware';
import { localStorage } from './index';


const storageObject = {

    setItem: (
        name: string,
        value: string
    ): void => {

        localStorage.set(
            name,
            value
        );
    },

    getItem: (
        name: string
    ): string | null => {

        return localStorage.get(name);
    },

    removeItem: (
        name: string
    ): void => {

        localStorage.remove(name);
    },
};

export const zustandStorageMiddleware = createJSONStorage(() => storageObject);